/* Contains the default layouts structure for each page */

import { PAGE_REFERENCES } from "@/store/constants/references"
import getHomePageDefaultLayout from "@/components/shared/pages/default-layouts/homepage.js"
import getPortfolioPageDefaultLayout from "@/components/shared/pages/default-layouts/portfolio.js"
import getForecastingDefaultLayout from "@/components/shared/pages/default-layouts/forecasting.js"
import getProspectingDefaultLayout from "@/components/shared/pages/default-layouts/prospecting.js"
import getObjectsProfilesDefaultLayout from "@/components/shared/pages/default-layouts/objects-pages.js"
import getCustomerJourneysDefaultLayout from "@/components/shared/pages/default-layouts/customer-journeys.js"

const getPageDefaultLayout = (page_reference, sub_page_reference = null, isModuleActivated) => {
  // switch between pages
  switch (page_reference) {
    case PAGE_REFERENCES.HOMEPAGE:
      return getHomePageDefaultLayout(sub_page_reference, isModuleActivated)
    case PAGE_REFERENCES.PORTFOLIO:
      // for the main portfolio the sub_page_reference is the object_type
      return getPortfolioPageDefaultLayout(sub_page_reference)
    case PAGE_REFERENCES.FORECASTING:
      return getForecastingDefaultLayout(sub_page_reference)
    case PAGE_REFERENCES.PROSPECTING:
      return getProspectingDefaultLayout(sub_page_reference, isModuleActivated)
    case PAGE_REFERENCES.COMPANY_PROFILE:
    case PAGE_REFERENCES.OBJECT_PROFILE:
    case PAGE_REFERENCES.CONTACT_PROFILE:
      return getObjectsProfilesDefaultLayout(page_reference, sub_page_reference)
    case PAGE_REFERENCES.CUSTOMER_JOURNEYS:
      return getCustomerJourneysDefaultLayout(sub_page_reference, isModuleActivated)
    default:
      return [[], null, null]
  }
}

export default getPageDefaultLayout
